import React from 'react';

import type { IconType, IconBaseProps } from 'react-icons/lib';
import IcoMoon from 'react-icomoon';

import iconSet from 'assets/svg/new-selection.json';

import type { IconTypes } from './icon.types';

export interface IconProps extends IconBaseProps {
  icon: IconTypes;
}

const Icon: React.FC<IconProps> = ({ icon, size = 24, style, ...rest }) => {
  // Check if the icon is a react-icons component
  if (typeof icon === 'function') {
    const ReactIconComponent = icon as IconType;
    return <ReactIconComponent size={size} style={style} {...rest} />;
  }

  // If the icon is not a react-icons component, it should be a custom icon from icomoon
  if (typeof icon === 'string') {
    return (
      <IcoMoon
        iconSet={iconSet}
        icon={icon}
        size={size}
        style={{ ...style, stroke: 'inherit' }}
        {...rest}
      />
    );
  }

  return null;
};

export default Icon;
